module.exports = "/_next/static/images/peaceOut-d713bea5e808df8df68e5d60f2d7b190.png";